import styles from 'css/src/components/common/ui/HiddenContainer.module.scss';

import React from 'react';
import classNames from 'classnames';

type Props = {
    isHidden?: boolean;
    isHeightInherited?: boolean;
    lazy?: boolean;
    children?: React.ReactNode;
    ['data-testid']?: string;
};
const HiddenContainer = ({
    isHidden = false,
    isHeightInherited = true,
    lazy = false,
    children,
    'data-testid': dataTestId,
}: Props) => {
    const [hasBeenVisible, setHasBeenVisible] = React.useState(!isHidden);

    // Once container becomes visible, mark it as mounted so children stay in DOM
    React.useEffect(() => {
        if (!isHidden && !hasBeenVisible) {
            setHasBeenVisible(true);
        }
    }, [isHidden, hasBeenVisible]);

    // In lazy mode: only render children if they've been visible before or are currently visible
    const shouldRenderChildren = !lazy || hasBeenVisible;

    const classname = classNames(
        {
            [styles['inherit-height']]: isHeightInherited,
            [styles['invisible']]: isHidden,
        },
        styles['hidden-container'],
    );
    return (
        <div className={classname} data-testid={dataTestId}>
            {shouldRenderChildren ? children : null}
        </div>
    );
};

const MemoizedHiddenContainer = React.memo(HiddenContainer);
export default MemoizedHiddenContainer;
export { HiddenContainer };
